import { render, staticRenderFns } from "./ClipIcon.vue?vue&type=template&id=e63f2a72"
import script from "./ClipIcon.vue?vue&type=script&lang=js"
export * from "./ClipIcon.vue?vue&type=script&lang=js"
import style0 from "./ClipIcon.vue?vue&type=style&index=0&id=e63f2a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports